import React from 'react';

const WhyChooseUs = () => {
  const features = [
    {
      icon: '🏆',
      title: 'Official SBI & IDFC First Bank Partner',
      description: 'Dual bank partnerships giving you freedom to choose between India\'s top FASTag issuers'
    },
    {
      icon: '⚡',
      title: '24/7 Dedicated Support',
      description: 'Always-on troubleshooting for Agents with uninterrupted query resolution'
    },
    {
      icon: '📦',
      title: 'End-to-End Convenience',
      description: 'From online application to doorstep delivery, no visits to physical banks required'
    },
    {
      icon: '✅',
      title: '100% Online & Paperless Process',
      description: 'Quick, hassle-free registration with minimal documentation'
    },
    {
      icon: '💼',
      title: 'Maximum Commission Margin',
      description: 'Best in class returns for our agent partners'
    },
    {
      icon: '🚀',
      title: 'Instant Activation',
      description: 'Fast processing and quick activation of your FASTag'
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-4 text-neutral-900">Why Choose Us?</h2>
        <p className="text-center text-neutral-600 mb-12 max-w-2xl mx-auto">
          Your Fast Track to FASTag - Agent IDs & Doorstep Delivery
        </p>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {features.map((feature, index) => (
            <div key={index} className="text-center p-6 rounded-lg hover:bg-neutral-50 transition">
              <div className="text-5xl mb-4">{feature.icon}</div>
              <h3 className="text-xl font-semibold mb-3 text-neutral-900">{feature.title}</h3>
              <p className="text-neutral-600">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
